import axios from "axios";
import authService from "./authService";
import { getLanguage } from "../utils/LocaleUtil";

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_ROUTE = "/api/v1/hubspot";

class HubspotService {
  // Check if contact exists
  static async checkContact() {
    try {
      const response = await axios.post(
        `${BACKEND_BASE_URL}${BASE_ROUTE}/check-contact`,
        null,
        authService.getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error("HubSpot Contact Check Error:", error);
      return { success: false, exists: false };
    }
  }

  // Create or update contact based on conditions
  static async createOrUpdateContact(properties: any, forWho?: string | null) {
    try {
      const response = await axios.post(
        `${BACKEND_BASE_URL}${BASE_ROUTE}/contact`,
        { properties, forWho, language: getLanguage() },
        authService.getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error("HubSpot Contact Update Error:", error);
      return { success: false };
    }
  }

  // Track custom event
  static async trackEvent(eventName: string, properties: any = {}) {
    try {
      const response = await axios.post(
        `${BACKEND_BASE_URL}${BASE_ROUTE}/track-event`,
        {
          eventName,
          properties,
          language: getLanguage(),
        },
        authService.getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error("HubSpot Event Tracking Error:", error);
      return { success: false };
    }
  }
}

export default HubspotService;
